import React, { useEffect, useRef, useState } from "react";
import "./Testimonial.scss";
import quoteimg from "../../assets/images/quote.png";
const testimonials = [
  {
    quote:
      "ZERO simplified medical policy management for our Omani and expatriate customers alike. Payments, renewals, and coverage tracking are now seamless and reliable.",
    author: "KHALID AL SAADI",
    company: "AL NOOR HEALTHCARE"
  },
  {
    quote:
      "Our customers appreciate the transparency and speed. Claims are processed faster, and policy management is fully digital, which has improved overall satisfaction.",
    author: "AISHA AL LAWATI",
    company: "UNITED MEDICAL SERVICES"
  },
  {
    quote:
      "ZERO brought consistency and confidence to our operations. Even during high demand periods, the system performs flawlessly.",
    author: "MOHAMMED AL HARTI",
    company: "GULF CARE INSURANCE"
  }
];

const AUTO_SLIDE_DELAY = 5000;

const Testimonial = () => {
  const [active, setActive] = useState(0);
  const startX = useRef(0);
  const autoSlideRef = useRef(null);

  //  Auto slide
  useEffect(() => {
    autoSlideRef.current = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, AUTO_SLIDE_DELAY);

    return () => clearInterval(autoSlideRef.current);
  }, []);

  //  Pause auto slide on manual interaction
  const stopAutoSlide = () => {
    clearInterval(autoSlideRef.current);
  };

  //  Swipe handlers
  const onTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    stopAutoSlide();
  };

  const onTouchEnd = (e) => {
    const diff = startX.current - e.changedTouches[0].clientX;
    if (diff > 50) next();
    if (diff < -50) prev();
  };

  const next = () => {
    setActive((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setActive((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <div
      className="testimonial-wrapper"
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <div className="testimonial-slider">
        {testimonials.map((item, index) => (
          <div
            key={index}
            className={`testimonial-slide ${
              index === active ? "active" : ""
            }`}
          >
            <div className="testimonial-card text-center">
              <div className="testimonial-quote"><img src={quoteimg} alt="icon" className="quoteImg" /> </div>
              <p className="testimonial-text">{item.quote}</p>
              <div className="testimonial-author">
                <strong>{item.author}</strong>
                <span>{item.company}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* DOT NAV */}
      <div className="scroll-dots">
        {testimonials.map((_, index) => (
          <span
            key={index}
            className={`dot ${active === index ? "active" : ""}`}
            onClick={() => {
              stopAutoSlide();
              setActive(index);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
